// removed by extract-text-webpack-plugin
module.exports = {"pageTitle":"style__pageTitle___2B_Xb"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SalesOrderDetail/style.scss
// module id = 1873
// module chunks = 0